"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedIndex = void 0;
function getSelectedIndex(options, value, valueGetter, comparator) {
    let result = undefined;
    options.some((item, idx) => {
        if (comparator(valueGetter(item), value)) {
            result = idx;
            return true;
        }
        return false;
    });
    return result;
}
exports.getSelectedIndex = getSelectedIndex;
//# sourceMappingURL=getSelectedIndex.js.map